import { useContext, useMemo } from 'react'
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Tooltip,
} from '@mui/material'
import { HEADER_HEIGHT } from 'components/Header'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import MenuIcon from '@mui/icons-material/Menu'
import { getSidebarItems } from 'consts/sidebar-items'
import { useNavigate, matchPath, useLocation } from 'react-router-dom'
import { SidebarSettingsContext } from 'providers/SidebarSettingsProvider'
import { useTranslation } from 'react-i18next'
import { useUserCurrentQuery } from 'services/users'

export const Sidebar = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isOpen, toggleOpen } = useContext(SidebarSettingsContext) ?? {}
  const { t } = useTranslation()

  const { data: user } = useUserCurrentQuery()

  const sideItems = useMemo(() => {
    if (user) {
      return getSidebarItems(user.userRoles, user.organizationType)
    }
  }, [user])

  return (
    <Box
      sx={{
        minWidth: isOpen ? 350 : 94,
        transition: 'width .2s ease-out',
        height: `calc(100vh - ${HEADER_HEIGHT}px)`,
        backgroundColor: (theme) => theme.palette.primary.main,
        paddingY: 1,
        paddingX: 1.5,
      }}
    >
      {isOpen ? (
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={toggleOpen}>
            <ArrowBackIcon color="secondary" />
          </IconButton>
        </Box>
      ) : (
        <Box>
          <IconButton onClick={toggleOpen}>
            <MenuIcon color="secondary" />
          </IconButton>
        </Box>
      )}

      <MenuList sx={{ maxHeight: 'calc(100% - 64px)', overflowY: 'scroll' }}>
        {sideItems &&
          sideItems.map(({ icon, path, textKey, roles, orgType }) => {
            const isActive = matchPath({ path }, location.pathname)
            return (
              <MenuItem
                key={textKey}
                sx={{
                  color: 'white',
                  paddingX: isOpen ? 1.5 : 1,
                  borderRadius: 1,
                  paddingY: 2,
                  ...(isActive && { background: 'rgba(255, 255, 255, .2)' }),
                }}
                onClick={() => navigate(path)}
              >
                <Tooltip placement="left" title={!isOpen ? t(textKey) : ''}>
                  <ListItemIcon>{icon}</ListItemIcon>
                </Tooltip>
                {isOpen && <ListItemText>{t(textKey)}</ListItemText>}
              </MenuItem>
            )
          })}
      </MenuList>
    </Box>
  )
}
